export const Nullable = <T,>(obj: T) => {
    return obj as {
        [P in keyof T]+?: T[P]
    }
}

export const objectWithType = <Type extends string, T>(type: Type, obj: T) => {
    return { ...obj, type: type }
}